import React, { useState, createContext } from 'react';
// Define the shape of our context
type FairContextType = {
  activeFair: any | null;
  setActiveFair: (fair: any | null) => void;
  clearActiveFair: () => void;
};
// Create the context with default values
export const FairContext = createContext<FairContextType>({
  activeFair: null,
  setActiveFair: () => {},
  clearActiveFair: () => {}
});
// Create the provider component
export const FairProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [activeFair, setActiveFair] = useState<any | null>(null);
  const clearActiveFair = () => {
    setActiveFair(null);
  };
  return <FairContext.Provider value={{
    activeFair,
    setActiveFair,
    clearActiveFair
  }} data-id="element-6984">
      {children}
    </FairContext.Provider>;
};